(() => {
  const SELECTOR = '[data-funny-scroll]';

  class FunnyScroll {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-fs-track]');
      this.group = root.querySelector('[data-fs-group]');
      if (!this.track || !this.group || !this.group.children.length) return;

      this.speed = Math.max(8, Number(root.dataset.speed || 26));
      this.resizeTimer = null;
      this.setup();
      this.bind();
    }

    setup() {
      this.track.querySelectorAll('[data-fs-clone]').forEach(node => node.remove());

      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.fsClone = 'true';
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      this.track.appendChild(clone);

      this.track.style.setProperty('--fs-duration', `${this.speed}s`);
      this.track.classList.add('is-ready');
    }

    bind() {
      window.addEventListener('resize', () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.setup(), 180);
      }, { passive: true });
    }
  }

  const init = scope => {
    const roots = scope.matches?.(SELECTOR) ? [scope] : [...(scope.querySelectorAll?.(SELECTOR) || [])];
    roots.forEach(root => {
      if (root.dataset.fsReady === 'true') return;
      root.dataset.fsReady = 'true';
      new FunnyScroll(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
